const defaults = {
  org: "satrack-ts",
  project: "Transformation-View",
  team: "SWAT",
  pat: "",
  sprintLimit: 3,
  classificationField: "Custom.806852b7-f5a5-422b-8cd5-304c07b73767",
  summaryField: "",
  sprintGoalField: "",
  completedStates: "Done,Closed,Resolved,Removed",
  proxyUrl: "",
  serverManagedAuth: false,
};

let runtime = { ...defaults };

export function setRuntimeConfig(partial = {}) {
  runtime = { ...runtime, ...partial };
  return runtime;
}

export function getRuntimeConfig() {
  return runtime;
}

export function sprintLimit() {
  const configured = Number(runtime.sprintLimit);
  return Number.isFinite(configured) && configured > 0 ? Math.trunc(configured) : 3;
}

export function applyEnvConfig(env = {}) {
  return setRuntimeConfig({
    org: env.AZURE_DEVOPS_ORG || defaults.org,
    project: env.AZURE_DEVOPS_PROJECT || defaults.project,
    team: env.AZURE_DEVOPS_TEAM || defaults.team,
    pat: env.AZURE_DEVOPS_PAT || "",
    sprintLimit: Number(env.SPRINT_LIMIT || defaults.sprintLimit),
    classificationField: env.AZURE_CLASSIFICATION_FIELD || defaults.classificationField,
    summaryField: env.AZURE_SUMMARY_FIELD || "",
    sprintGoalField: env.AZURE_SPRINT_GOAL_FIELD || "",
    completedStates: env.AZURE_COMPLETED_STATES || defaults.completedStates,
    proxyUrl: env.ADO_PROXY_URL || "",
    serverManagedAuth: Boolean(env.AZURE_DEVOPS_PAT),
  });
}
